import axios from 'axios'

const generateDailyLedgerExcel = async function(init_date, end_date, branchOffice = '') {
    try {
        const path = `/acc_daily_ledger/excel?init_date=${init_date}&end_date=${end_date}&g_branch_office_id=${branchOffice}`,
            route = process.env.VUE_APP_API_ROUTE.concat(path)
        let response = await axios({
            url: route,
            method: 'GET',
            responseType: 'blob',
        })
        return response
    } catch (error) {
        return error.response
    }
}

export { generateDailyLedgerExcel }
